import React, {PropTypes} from 'react';
import Week from './Week';

function prepareWeeks(timeSheets, daySelectCallback, selectedTimeSheet) {
    let weeks = [];
    weeks.push(timeSheets.slice(0, 5));
    weeks.push(timeSheets.slice(5, 10));
    return prepareWeeksNodes(weeks, daySelectCallback, selectedTimeSheet);
}

function prepareWeeksNodes(weeks, daySelectCallback, selectedTimeSheet) {
    const daySelect = (week) => daySelectCallback(week);
    return weeks.map((week, index) => (
        <Week key={index} week={week} selectedTimeSheet={selectedTimeSheet}
              onDaySelect={daySelect}/>));
}

const Timeline = ({timeSheets, selectedTimeSheet, onDaySelect}) => {
    const weeksNodes = prepareWeeks(timeSheets, onDaySelect, selectedTimeSheet);
    return (
        <div>
            {weeksNodes}
        </div>
    );
};

Timeline.propTypes = {
    timeSheets: PropTypes.array.isRequired,
    onDaySelect: PropTypes.func.isRequired,
    selectedTimeSheet: PropTypes.object
};

export default Timeline;


/** WEBPACK FOOTER **
 ** ./src/components/Timeline/index.js
 **/